
import { Component, TemplateRef } from '@angular/core';
import { FormsModule } from '@angular/forms';
import { removeFromArray } from '@reflact/tsutil';
import { SupervisorFunction } from '@shared/index';
import { BsModalRef, BsModalService } from 'ngx-bootstrap/modal';
import { MenuItem } from 'primeng/api';
import { ButtonModule } from 'primeng/button';
import { CardModule } from 'primeng/card';
import { DrawerModule } from 'primeng/drawer';
import { InputTextModule } from 'primeng/inputtext';
import { MenuModule } from 'primeng/menu';
import { MessageModule } from 'primeng/message';
import { TableModule } from 'primeng/table';
import { RouteShareService } from 'src/app/shared/services/route-share.service';
import { AdminBackButtonComponent } from "../../../../../../../shared/components/ai-bot/utils/admin-back-button/admin-back-button.component";
import { SupervisorService } from '../supervisor.service';
import { SupervisorFunctionsDetailsComponent } from './supervisor-functions-details/supervisor-functions-details.component';

@Component({
  selector: 'app-supervisor-functions',
  imports: [FormsModule,
    AdminBackButtonComponent,
    MessageModule,
    CardModule,
    InputTextModule,
    ButtonModule,
    TableModule,
    MenuModule,
    DrawerModule,
    SupervisorFunctionsDetailsComponent
  ],
  providers: [BsModalService],
  templateUrl: './supervisor-functions.component.html',
  styleUrl: './supervisor-functions.component.scss'
})
export class SupervisorFunctionsComponent {
  protected customFunctionName: string = '';
  protected selectedFunction: SupervisorFunction | undefined = undefined;
  public modalRef?: BsModalRef;
  public detailDrawer: boolean = false;
  public selectedFunctionId: string = '';
  public supervisorFunctionContextMenu: MenuItem[] = [];

  constructor(
    public rss: RouteShareService,
    private modalService: BsModalService,
    public supervisorService: SupervisorService
  ) { }

  public get customFunction(): SupervisorFunction[] {
    return this.rss.botConfig.supervisorFunctions;
  }

  public showDetailDrawer(id: string): void {
    this.selectedFunctionId = id;
    this.detailDrawer = true;
  }

  protected async addCustomFunction(): Promise<void> {
    const newCustomFunction: SupervisorFunction = {
      id: '',
      js: '',
      name: this.customFunctionName.trim()
    };
    this.rss.botConfig.supervisorFunctions.unshift(newCustomFunction);
    await this.rss.saveBotConfigField('supervisorFunctions');
    this.customFunctionName = '';
    const createdId = this.rss.botConfig.supervisorFunctions[0]?.id;
    if (createdId) this.showDetailDrawer(createdId);
  }

  public copyCustomFunction(id: string): void {
    const itemToCopy = this.rss.botConfig.supervisorFunctions.find(sf => sf.id === id);
    if (itemToCopy) {
      const itemWithoutId = structuredClone(itemToCopy);
      itemWithoutId.id = '';
      this.rss.botConfig.supervisorFunctions.unshift(itemWithoutId);
      void this.rss.saveBotConfigField('supervisorFunctions');
    }
  }

  protected removeCustomFunction(id: string): void {
    removeFromArray(this.rss.botConfig.supervisorFunctions, sf => sf.id === id);
    void this.rss.saveBotConfigField('supervisorFunctions');
  }

  protected confirmModal(tpl: TemplateRef<BsModalRef>) {
    this.modalRef = this.modalService.show(tpl);
  }

  public openSupervisorFunctionMenu(
    event: Event,
    menu: { toggle: (e: Event) => void },
    custom: SupervisorFunction,
    confirmTrigger: TemplateRef<BsModalRef>
  ): void {
    this.supervisorFunctionContextMenu = this.buildSupervisorFunctionMenuItems(custom, confirmTrigger);
    menu.toggle(event);
  }

  private buildSupervisorFunctionMenuItems(
    custom: SupervisorFunction,
    confirmTrigger: TemplateRef<BsModalRef>
  ): MenuItem[] {
    return [
      {
        label: $localize`:@@edit:Bearbeiten`,
        icon: 'ri ri-pencil-fill',
        command: () => this.showDetailDrawer(custom.id)
      },
      {
        label: $localize`:@@copy:Duplizieren`,
        icon: 'ri ri-file-copy-fill',
        command: () => { this.copyCustomFunction(custom.id); }
      },
      {
        label: $localize`:@@trigger-for-all-active-clients:An alle aktiven Clients senden`,
        icon: 'ri ri-send-plane-2-fill',
        command: () => {
          this.selectedFunction = custom;
          this.confirmModal(confirmTrigger);
        }
      },
      {
        label: $localize`:@@delete:Löschen`,
        icon: 'ri ri-close-large-fill',
        command: () => { this.removeCustomFunction(custom.id); },
        styleClass: 'text-danger'
      }
    ];
  }
}
